import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
    name: 'valueToMonth',
    standalone: false
})
export class ValueToMonthPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const months = moment.months();
    const month = value.toString().substring(4, 6);
    const year = value.toString().substring(0, 4);
    const index = parseInt(month, 10) - 1;
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    const isRolling = currentMonth === index && currentYear === year;

    return isRolling ? 'ANALYZE.ROLLING_MONTH' : months[index] + ' ' + year;
  }
}
